export const getDefaultVsic = (vsics, mainVsicId) => {
  const mainBusiness = vsics.find((item) => item.id === mainVsicId) || {}

  if ([1, 2, 3].includes(mainBusiness.level)) {
    return mainBusiness
  }

  if (mainBusiness.level === 4) {
    return getParentVsic(vsics, mainBusiness)
  }

  if (mainBusiness.level === 5) {
    const level4 = getParentVsic(vsics, mainBusiness)

    return getParentVsic(vsics, level4)
  }

  return {}
}

export const getDefaultVsicLevel1 = (vsics, mainVsicId) => {
  const mainBusiness = vsics.find((item) => item.id === mainVsicId) || {}

  if (mainBusiness.level === 1) {
    return mainBusiness
  }

  if (mainBusiness.level === 2) {
    return getParentVsic(vsics, mainBusiness)
  }

  if (mainBusiness.level === 3) {
    const level2 = getParentVsic(vsics, mainBusiness)

    return getParentVsic(vsics, level2)
  }

  if (mainBusiness.level === 4) {
    const level3 = getParentVsic(vsics, mainBusiness)
    const level2 = getParentVsic(vsics, level3)

    return getParentVsic(vsics, level2)
  }

  if (mainBusiness.level === 5) {
    const level4 = getParentVsic(vsics, mainBusiness)
    const level3 = getParentVsic(vsics, level4)
    const level2 = getParentVsic(vsics, level3)

    return getParentVsic(vsics, level2)
  }

  return {}
}

const getParentVsic = (vsics, vsic) => {
  return vsics.find((item) => item.id === vsic.parentId) || {}
}
